import { NavigateFunction } from "react-router-dom";
import { ErrorCodes } from "src/Logic/Models/General/technicalErrors";
import { OperatorRequester } from "src/Logic/Requesters/OperatorRequester";

export const updateParticipant = async (
    name: string,
    attributes: Record<string, any>,
    roomCode: string,
    requester: OperatorRequester,
    setTechnicalError: React.Dispatch<React.SetStateAction<ErrorCodes | number | null>>,
    setIsNoInternet: React.Dispatch<React.SetStateAction<boolean>>,
    navigate: NavigateFunction,
) => {
    if (!navigator.onLine) {
        setIsNoInternet(true);
    } else {
        try {
            await requester.UpdateParticipant(name, attributes, roomCode).then(async response => {
                if (response) {
                    if (response.status === 401) {
                        navigate('/sign-in');
                    } else if (response.status === 400) {
                        const body = await response.json();
                        if (body.errorCode) {
                            setTechnicalError(body.errorCode);
                        }
                    } else if (response.status !== 200) {
                        setTechnicalError(response.status);
                    }
                }
            });
        } catch (error) {
            console.log(error);
        }
    }
};
